import React, { useState } from 'react';
import { Layout as AntLayout, Menu, Typography, Badge, Space, Dropdown, Avatar, Button } from 'antd';
import { 
  DashboardOutlined, 
  LineChartOutlined, 
  SwapOutlined,
  CalculatorOutlined,
  FormOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  LogoutOutlined,
  SettingOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const { Header, Sider, Content } = AntLayout;
const { Title } = Typography;

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const selectedMenuKey = getSelectedMenuKey(location.pathname);

  const menuItems = [
    {
      key: '/dashboard/',
      icon: <DashboardOutlined />,
      label: '即時監控',
    },
    {
      key: '/dashboard/historical',
      icon: <LineChartOutlined />,
      label: '歷史分析',
    },
    {
      key: '/dashboard/binance-transfer',
      icon: <SwapOutlined />,
      label: 'Binance 轉換/提幣',
    },
    {
      key: '/dashboard/profit-report',
      icon: <CalculatorOutlined />,
      label: '損益儀表板',
    },
    {
      key: '/dashboard/profit-cycles/new',
      icon: <FormOutlined />,
      label: '新增套利循環',
    },
  ];

  const bottomMenuItems = [
    {
      key: '/dashboard/config',
      icon: <SettingOutlined />,
      label: '系統設定',
    },
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '個人資料',
      disabled: true,
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: '系統設定',
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '登出',
      onClick: handleLogout,
    },
  ];

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider 
        trigger={null} 
        collapsible 
        collapsed={collapsed}
        width={240}
        breakpoint="md"
        onBreakpoint={broken => {
          if (broken) {
            setCollapsed(true);
          }
        }}
        collapsedWidth={0}
        style={{
          background: '#1a1f2e',
          borderRight: '1px solid #2a2f3e',
        }}
      >
        <div style={{ 
          padding: '16px', 
          textAlign: 'center',
          borderBottom: '1px solid #2a2f3e',
          height: '64px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {!collapsed ? (
            <Title level={4} style={{
              color: '#00A3FF',
              margin: 0,
              fontSize: '20px',
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center'
            }}>
                <img src="/android-chrome-192x192.png" alt="ArbiPro logo" style={{ width: '28px', height: '28px', marginRight: '12px' }} />
               ArbiPro
             </Title>
          ) : (
           <img src="/android-chrome-192x192.png" alt="ArbiPro logo" style={{ width: '32px', height: '32px' }} />
          )}
        </div>
        
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100vh - 64px)',
          }}
        >
          <Menu
            mode="inline"
            selectedKeys={selectedMenuKey ? [selectedMenuKey] : []}
            items={menuItems}
            onClick={handleMenuClick}
            style={{
              background: 'transparent',
              border: 'none',
              marginTop: '16px',
              flex: 1,
            }}
          />
          <Menu
            mode="inline"
            selectedKeys={selectedMenuKey ? [selectedMenuKey] : []}
            items={bottomMenuItems}
            onClick={handleMenuClick}
            style={{
              background: 'transparent',
              border: 'none',
              borderTop: '1px solid #2a2f3e',
              paddingBottom: 16,
            }}
          />
        </div>
      </Sider>
      
      <AntLayout>
        <Header style={{
          background: '#1a1f2e',
          padding: '0 24px',
          borderBottom: '1px solid #2a2f3e',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <Space>
            {React.createElement(
              collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
              {
                style: { 
                  fontSize: '18px', 
                  color: '#f0f6fc',
                  cursor: 'pointer',
                  padding: '8px',
                  borderRadius: '4px',
                  transition: 'background 0.2s'
                },
                onClick: () => setCollapsed(!collapsed),
                onMouseEnter: (e) => e.target.style.background = '#21262d',
                onMouseLeave: (e) => e.target.style.background = 'transparent'
              }
            )}
            <Title level={3} style={{ 
              color: '#f0f6fc', 
              margin: 0,
              fontSize: '20px',
              fontWeight: 600
            }}>
              {getPageTitle(location.pathname)}
            </Title>
          </Space>
          
          <Space size="large">
            <Badge 
              status="processing" 
              text={
                <span style={{ color: '#8b949e', fontSize: '14px' }}>
                  系統運行中
                </span>
              } 
            />
            <Dropdown
              menu={{ 
                items: userMenuItems,
                onClick: ({ key }) => {
                  if (key === 'logout') {
                    handleLogout();
                  }
                }
              }}
              placement="bottomRight"
              trigger={['click']}
            >
              <Button
                type="text"
                style={{
                  height: 'auto',
                  padding: '4px 8px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  color: '#f0f6fc',
                  border: '1px solid transparent',
                  borderRadius: '6px',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#21262d';
                  e.target.style.borderColor = '#2a2f3e';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.borderColor = 'transparent';
                }}
              >
                <Avatar 
                  size="small" 
                  icon={<UserOutlined />} 
                  style={{ 
                    backgroundColor: '#00A3FF',
                    fontSize: '12px'
                  }} 
                />
                {!collapsed && (
                  <Space direction="vertical" size={0} style={{ lineHeight: 1 }}>
                    <span style={{ fontSize: '13px', fontWeight: 500 }}>
                      {user?.name || 'Professional User'}
                    </span>
                    <span style={{ fontSize: '11px', color: '#8b949e' }}>
                      {user?.role || 'Trader'}
                    </span>
                  </Space>
                )}
              </Button>
            </Dropdown>
          </Space>
        </Header>
        
        <Content style={{
          background: '#0f1419',
          padding: '24px',
          minHeight: 'calc(100vh - 64px)',
          overflow: 'auto'
        }}>
          {children}
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

const getPageTitle = (pathname) => {
  if (pathname === '/dashboard/profit-cycles/new') {
    return '新增套利循環';
  }
  if (pathname.startsWith('/dashboard/profit-cycles/') && pathname.endsWith('/edit')) {
    return '編輯套利循環';
  }

  switch (pathname) {
    case '/dashboard/':
    case '/dashboard':
      return '即時監控儀表板';
    case '/dashboard/historical':
      return '歷史趨勢分析';
    case '/dashboard/withdrawals':
      return '出金歷史紀錄';
    case '/dashboard/binance-transfer':
      return 'Binance 轉換/提幣';
    case '/dashboard/profit-report':
      return '套利損益儀表板';
    case '/dashboard/config':
      return '系統設定';
    default:
      return '套利監控系統';
  }
};

const getSelectedMenuKey = (pathname) => {
  if (pathname.startsWith('/dashboard/profit-cycles/') && pathname.endsWith('/edit')) {
    return '/dashboard/profit-cycles/new';
  }
  return pathname;
};

export default Layout;
